<div class="mb-8 flex items-center">
  <!-- Header -->
  <div class="flex flex-grow flex-col">
    <span class="text-2xl font-bold">Welcome, {{ userName }}</span>
    <span class="text-base">{{ userOrganization }}</span>
  </div>

  <!-- Nav -->
  <div class="trial-insights-nav-container">
    @if (showClinOpsButton$ | async) {
      <a
        [routerLink]="clinicalRouterLink"
        (click)="setActive(RouterLinks.Clinical)"
        [ngClass]="isActive(RouterLinks.Clinical) ? 'btn--primary' : 'btn--secondary'"
      >
        ClinOps
      </a>
    }

    @if (showFinanceButton$ | async) {
      <a
        [routerLink]="financeRouterLink"
        (click)="setActive(RouterLinks.Finance)"
        [ngClass]="isActive(RouterLinks.Finance) ? 'btn--primary' : 'btn--secondary'"
      >
        Finance
      </a>
    }
  </div>
</div>
